import Container from '@/components/Container';

export const KeyDatesListLoading = () => {
  return (
    <Container className="min-h-40">
      <div className="col-span-12 lg:col-start-3 lg:col-end-11">
        <div className="mb-sh-30 animate-pulse">
          <div className="h-8 w-48 rounded bg-gray-200" />
        </div>
        <div className="mb-sh-15 h-10 w-64 rounded bg-gray-200" />
        <div className="mb-sh-30 h-6 w-full max-w-xl rounded bg-gray-200" />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="animate-pulse rounded-2xl border border-gray-200 bg-white p-4">
              <div className="mb-3 h-6 w-32 rounded-2xl bg-gray-200" />
              <div className="mb-2 h-5 w-3/4 rounded bg-gray-200" />
              <div className="mb-3 flex gap-2">
                <div className="h-6 w-20 rounded-2xl bg-gray-200" />
                <div className="h-6 w-20 rounded-2xl bg-gray-200" />
              </div>
              <div className="mb-2 h-4 w-full rounded bg-gray-200" />
              <div className="h-4 w-2/3 rounded bg-gray-200" />
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};
